<!-- 设备管理报表 -->
<template>
  <div class="container">
      <div class="search-top">
        <!-- <h1 class="titleStyle">设备管理报表</h1> -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="IMEI：">
              <el-input  v-model='Dform.imei' placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="名称：">
              <el-input  v-model='Dform.name' placeholder=""></el-input>
            </el-form-item></el-col>

          <el-col :span="6">
            <el-form-item label="设备选项：">
              <el-select v-model="Dform.typeValue" placeholder="--请选择--">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item></el-col>
     
          <el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
        </el-row>
      </div>
      <div class="main-content">
        <el-table
          class="table-Style"
          stripe
          :border="true"
          v-loading="loading"
          :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="imei"
            label="IMEI"
           >
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
           >
          </el-table-column>
          <el-table-column
            label="所属单位">
            <template #default="scope">
              <span v-if="scope.row.alias != null">{{scope.row.alias}}</span>
              <span v-else>{{scope.row.userName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="设备手机号"
           >
          </el-table-column>
          <!-- <el-table-column
            prop="devtime"
            label="设备使用时间（天）"
            >
          </el-table-column> -->
          <el-table-column
            prop="expirationTime"
            label="到期时间">
          </el-table-column>
        </el-table> 
        <div class="block">
              <!-- <span class="demonstration">直接前往</span> -->
              <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage3"
              :page-size="pageInfo.pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
              </el-pagination>
           </div>
      </div>
  </div>
</template>

<script>
import { deviceManagement } from '@/assets/api/api'
export default {
  components: {

  },
  data() {
      return {
        loading:true,
        tableData: [],
        options: [{
          value: '1',
          label: '全部'
        }, {
          value: '2',
          label: '7天内过期设备'
        },{
          value: '3',
          label: '60天内过期设备'
        },
        {
          value: '4',
          label: '已过期设备'
        }],
        Dform: {
          imei: '',
          name: '',
          typeValue: '1',
        },
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        total: 0
      };
  },
  created() {
    this.deviceManagementClick()
  },
  mounted() {

  },
  methods: {
    inquiryClick() {
      this.pageInfo.page = 1
      this.total = 0
      this.deviceManagementClick()
    },
    deviceManagementClick () {
      let params = {
        imei:this.Dform.imei,
        name:this.Dform.name,
        type: this.Dform.typeValue,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      deviceManagement(params).then((res)=> {
        this.tableData = res.data.list
        this.total = res.data.total
        console.log(this.tableData,res,'设备管理报表接口');
        this.loading = false
      }).catch((err)=> {
          console.log(err);
      })
    },
    handleNodeClick(data){
        console.log(data,'树形组件');
    },
      handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.deviceManagementClick()
    }
  },
};
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 96%;
    border-radius: 8px;
    .search-top {
      height: 100px;
      background-color: #FFF;
      border-radius: 15px;
      display: flex;
      align-content: space-around;  
      align-items: center;
      .titleStyle{
        margin-left: 40px;
        font-size: 20px;
        font-weight: 700;
        width: 45%;
      }
      .query-button {
          padding: 15px 23px;
          // background-color:#1BC896;
          border-radius: 15px;
        }
      :deep() {
        .el-dropdown-link {
          cursor: pointer;
          // color: #409EFF;
        }
        .el-select--small .el-select__wrapper {
          height: 35px;
          border-radius: 15px
              ;
          
        }
      .el-col-6{
        max-width: 24%;
        margin-top: 20px;
        margin-left: 30px;

      }
      .el-button--small {
        margin-top:20px;
        margin-left: 60px;
        margin-right: 20px;
      }
      .el-form-item--small .el-form-item__label{
        line-height: 32px;
        font-size: 16px;
        font-weight: 700;

      }
      
      .el-input--small .el-input__inner{
        height: 30px;
        line-height: 30px;
      } 
      .el-form-item {
            width: 109%;
            margin-left: 15px;
          }
          .el-input--small .el-input__wrapper{
              margin-right: 15px;
              border-radius: 15px
              ;
            }
      }
    }
    .main-content{
      margin-top: 15px;
     height: 85%;
      overflow: auto;
      position: relative;
      padding: 0px 15px;
      padding-top: 30px;
      margin-top: 15px;
      background-color: #FFF;
      border-radius: 15px;
      .table-Style{
        font-size: 16px;
        // border-radius: 15px;
      }
    :deep() {
      .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
            // border: 0px;
          }
          .el-table th.el-table__cell>.cell{
            font-weight: 700;

          }
      .el-pagination{
        font-size: 16px;
        margin-left: 600px;
        margin-top: 20px;
      }
      .el-table--small .el-table__cell{
        // font-size: 14px;
        font-size: 16px;
            color: black;
        padding: 8px 10px;
        text-align: center;
      }
    }
    }
}

</style>
